import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules, NoPreloading } from '@angular/router';
import { CheckAuth } from './core/guard';
import { QuicklinkStrategy } from 'ngx-quicklink';
import { AfterLoginLayoutComponent } from './layout/after-login-layout/after-login-layout.component';
import { loginLayoutComponent } from './layout/login-layout/login-layout.component';
import { ProfileLayoutComponent } from './layout/profile-layout/profile-layout.component';
import { NotFoundComponent } from './shared/not-found/not-found.component';
import { CustomerLayoutComponent } from './layout/customer-layout/customer-layout.component';
import { CheckAlreadyLogin } from './core/guard';
import { BeforeLoginLayoutComponent } from './layout/before-login-layout/before-login-layout.component';
import { DownloadPrintLayoutComponent } from './layout/download-print-layout/download-print-layout.component';


const routes: Routes = [
  {
    path: '',
    component: loginLayoutComponent,
    canActivate: [CheckAlreadyLogin],
    loadChildren: () => import('./modules/auth/auth.module').then(m => m.authContentModule)
  },
  {
    path: '',
    component: loginLayoutComponent,
    canActivate: [CheckAuth],
    loadChildren: () => import('./modules/auth/intro-kyc/intro-kyc.module').then(m => m.introKycModule)
  },
  {
    path: '',
    component: BeforeLoginLayoutComponent,
    canActivate: [CheckAuth],
    loadChildren: () => import('./modules/auth/kyc-acc-activation/kyc-acc-activation.module').then(m => m.KycAccActivationModule)
  },
  {
    path: '',
    component: BeforeLoginLayoutComponent,
    canActivate: [CheckAuth],
    loadChildren: () => import('./modules/auth/review-kyc-acc/review-kyc-acc.module').then(m => m.ReviewKycAccActivationModule)
  },
  {
    path: '',
    component: DownloadPrintLayoutComponent,
    canActivate: [CheckAuth],
    loadChildren: () => import('./modules/invoice/summary-invoice/summary-invoice.module').then(m => m.SummaryInvoiceModule)
  },
  {
    path: '',
    component: AfterLoginLayoutComponent,
    canActivate: [CheckAuth],
    children: [
      {
        path: 'invoice',
        loadChildren: () => import('./modules/invoice/invoice.module').then(m => m.InvoiceModule)
      }
    ]
  },
  {
    path: '',
    component: CustomerLayoutComponent,
    //canActivate: [CheckAuth],
    children: [
      {
        path: 'customer',
        loadChildren: () => import('./modules/customer/customer.module').then(m => m.CustomerModule)
      }
    ]
  },
  {
    path: '',
    component: AfterLoginLayoutComponent,
    canActivate: [CheckAuth],
    children: [
      {
        path: 'customers',
        loadChildren: () => import('./modules/customers/customers.module').then(m => m.CustomerModule)
      }
    ]
  },

 

  {
    path: '',
    component: BeforeLoginLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./modules/auth/reset-password-form/reset-password.module').then(m => m.ResetPasswordModule)
      }
    ]
  },

  {
    path: '',
    component: AfterLoginLayoutComponent,
    canActivate: [CheckAuth],
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule)
      }
    ]
  },

  {
    path: '',
    component: AfterLoginLayoutComponent,
    canActivate: [CheckAuth],
    children: [
      {
        path: 'products',
        loadChildren: () => import('./modules/products/products.module').then(m => m.ProductsModule)
      }
    ]
  },
  {
    path: '',
    component: AfterLoginLayoutComponent,
    canActivate: [CheckAuth],
    children: [
      {
        path: 'payments',
        loadChildren: () => import('./modules/payments/payments.module').then(m => m.PaymentsModule)
      }
    ]
  },
  {
    path: '',
    component: AfterLoginLayoutComponent,
    canActivate: [CheckAuth],
    children: [
      {
        path: 'reports',
        loadChildren: () => import('./modules/reports/reports.module').then(m => m.ReportsModule)
      }
    ]
  },
  {
    path: '',
    component: AfterLoginLayoutComponent,
    canActivate: [CheckAuth],
    children: [
      {
        path: 'support',
        loadChildren: () => import('./modules/support/support.module').then(m => m.SupportModule)
      }
    ]
  },
  {
    path: '',
    component: AfterLoginLayoutComponent,
    canActivate: [CheckAuth],
    children: [
      {
        path: 'profile',
        loadChildren: () => import('./modules/profile/profile.module').then(m => m.ProfileModule)
      }
    ]

  },
  {
    path: '**',
    pathMatch: 'full', 
    component: NotFoundComponent
  },

 
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false, preloadingStrategy: QuicklinkStrategy, relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})

export class AppRoutingModule { }
